import { render, staticRenderFns } from "./HochiScope.vue?vue&type=template&id=c9da0e98"
import script from "./HochiScope.vue?vue&type=script&lang=js"
export * from "./HochiScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports